export const handleKhLinks = (() => {
    const _config = {
        selectors: {
            khLinks: document.querySelectorAll('.open-kh-link'),
            showGuidedSelling: '.show-guided-selling'
        }
    };

    const init = () => {
        if (_config.selectors.khLinks.length) {
            _addEventListeners();
        }
    };

    const _addEventListeners = () => {
        _config.selectors.khLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (!_detectKh()) {
                    _returnToParentCategory();
                } else {
                    document.querySelector(_config.selectors.showGuidedSelling).click();
                }
            });
        });
    };

    const _detectKh = () => {
        return Boolean(document.querySelectorAll(_config.selectors.showGuidedSelling).length);
    };

    const _returnToParentCategory = () => {
        window.location.href = '..';
        localStorage.setItem('showGuidedSelling', 'true');
    };

    return {
        init: init
    };
})();
